import { render, staticRenderFns } from "./SetNewPasswordPage.vue?vue&type=template&id=81c5a38c&scoped=true&"
import script from "./SetNewPasswordPage.vue?vue&type=script&lang=js&"
export * from "./SetNewPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./SetNewPasswordPage.vue?vue&type=style&index=0&id=81c5a38c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c5a38c",
  null
  
)

export default component.exports